<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="user-box">
    <!-- <s-header :name="'我的'" :noback="true"></s-header> -->
    <van-skeleton title :avatar="true" :row="3" :loading="loading">
      <div class="user-info">
        <div class="info">
          <img src="https://s.yezgea02.com/1604040746310/aaaddd.png" />
          <div class="user-desc">
            <div class="name_warp">
              <span class="name" style="width: 18%">昵称：</span>
              <span class="name" style="width: 82%">
                {{ user.nickName }}
              </span>
              <div style="clear: both"></div>
            </div>
            <div>登录名：{{ user.loginName }}</div>
          </div>
          <van-icon
            v-show="false"
            class="setting"
            name="setting"
            @click="goTo('/setting')"
          />
        </div>
      </div>
    </van-skeleton>
    <div class="user-list">
      <div class="user-domain">
        <div @click="goBalance">0<br /><span>余额</span></div>
        <div class="dkq" @click="goTo('/Discount')">
          {{ coupon }}<br /><span>抵扣券(张)</span>
        </div>
        <div @click="goTo('/address', { from: 'mine' })">
          <van-icon name="location" /><br /><span>收货地址</span>
        </div>
      </div>
      <div class="user-order">
        <div class="order-title">
          <div><h3>我的订单</h3></div>
          <div style="line-height: 50px" @click="goTo('/order', { name: '' })">
            全部订单>
          </div>
        </div>
        <div class="order-domain">
          <div @click="goTo('/order', { name: '0' })">
            <div class="domainwarp">
              <img src="../assets/dfk.png" alt="" />
            </div>
            <span>待付款</span>
          </div>
          <!-- <div @click="goTo('/order', { name: 'b' })"><i></i><br /><span>待确认</span></div> -->
          <div @click="goTo('/order', { name: '4' })">
            <div class="domainwarp"><img src="../assets/ywc.png" alt="" /></div>
            <span>已完成</span>
          </div>
        </div>
      </div>

      <div class="user-order">
        <div class="order-title">
          <div><h3>我的发票</h3></div>
        </div>
        <div class="order-domain">
          <!-- <div @click="goTo('/Apply')"> -->
          <div @click="goApply">
            <div class="domainwarp">
              <img src="../assets/apply.png" alt="" />
            </div>
            <span>申请发票</span>
          </div>
          <!-- <div @click="goTo('/order', { name: 'b' })"><i></i><br /><span>待确认</span></div> -->
          <div @click="goTo('/Applyhistory')">
            <div class="domainwarp">
              <img src="../assets/history.png" alt="" />
            </div>
            <span>开票历史</span>
          </div>
        </div>
      </div>
    </div>
    <nav-bar></nav-bar>
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from 'vue'
import navBar from '@/components/NavBar'
import { getUserInfo, getQuantity } from '@/service/user'
import { useRouter } from 'vue-router'
import { Toast,Dialog } from 'vant'

export default {
  components: {
    navBar
  },
  setup() {
    const router = useRouter()
    const state = reactive({
      user: {},
      loading: true,
      coupon: null
    })

    onMounted(async () => {
      const { data } = await getUserInfo()
      state.user = data
      state.loading = false
      getQuantity().then((res) => {
        state.coupon = res.data
      })
    })

    const goBack = () => {
      router.go(-1)
    }

    const goTo = (r, query) => {
      router.push({ path: r, query: query || {} })
    }
    const goBalance = () => {
      Toast('功能暂未开放')
    }
    const goApply = () => {
      if(state.user.isVisitor === 0 ) { //0.不完善 1.已完善
        Dialog.alert({
        // title: '标题',
        message: '申请开票需要先完善企业信息',
        confirmButtonText: '去完善'
        }).then(() => {
          window.wx.miniProgram.navigateTo({
            url: '/pages/contactInfo/contactInfo'
          })
        })
      }else{
        router.push({
          path: '/Apply'
        })
      }
      
    }
    return {
      ...toRefs(state),
      goBack,
      goTo,
      goBalance,
      goApply
    }
  }
}
</script>

<style lang="less" scoped>
@import '../common/style/mixin';
.user-box {
  background: #f9f9f9;

  .user-header {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10000;
    .fj();
    .wh(100%, 44px);
    line-height: 44px;
    padding: 0 10px;
    .boxSizing();
    color: #252525;
    background: #fff;
    border-bottom: 1px solid #dcdcdc;
    .user-name {
      font-size: 14px;
    }
  }
  .user-info {
    background: linear-gradient(90deg, @primary, #40c6ff);
    .info {
      position: relative;
      display: flex;
      width: 100%;
      height: 100%;
      padding: 50px 20px;
      top: -10px;
      .boxSizing();
      img {
        .wh(60px, 60px);
        border-radius: 50%;
        margin-top: 4px;
      }
      .user-desc {
        flex-direction: column;
        line-height: 20px;
        font-size: 14px;
        color: #fff;
        margin-left: 15px;
        width: 100%;
        span {
          color: #fff;
          font-size: 14px;
          padding: 8px 0;
        }
        .name_warp {
          .name {
            float: left;
            color: #fff;
            font-size: 14px;
            padding: 8px 0;
            margin: 0;
          }
        }
      }
      .account-setting {
        position: absolute;
        top: 10px;
        right: 20px;
        font-size: 13px;
        color: #fff;
        .van-icon-setting-o {
          font-size: 16px;
          vertical-align: -3px;
          margin-right: 4px;
        }
      }
    }
  }
  .user-list {
    padding: 20px 20px;
    background: #f9f9f9;
    border-radius: 50px;
    position: relative;
    border-radius: 15px;
    top: -25px;
    .user-domain {
      background: #fff;
      display: flex;
      justify-content: space-between;
      padding: 20px 20px;
      border-radius: 10px;
      div {
        width: 80px;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        span {
          font-size: 12px;
          font-weight: 500;
        }
      }
    }
    .user-order {
      background: #fff;
      border-radius: 15px;
      margin: 10px 0;
      .order-title {
        height: 50px;
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
      }
      .order-domain {
        padding: 10px 30px;
        display: flex;
        justify-content: space-around;
        div {
          width: 80px;
          text-align: center;
        }
        .domainwarp {
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        img {
          width: 20px;
        }
        span {
          display: block;
          padding-top: 5px;
        }
      }
    }
  }
  .dkq {
    padding: 0 15px;
    border-right: 1px #ededed solid;
    border-left: 1px #ededed solid;
  }
  .setting {
    font-size: 20px;
    color: #fff;
  }
  .clear {
    clear: both;
  }
}
</style>
